window.tagalysIcon = {
  view3: function(html) {
    return html`
      <svg width="23" height="20" viewBox="0 0 23 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
          x="0.350037"
          y="0.25"
          width="5.5"
          height="19.5"
          rx="1.75"
          fill="white"
          stroke="#999999"
          stroke-width="0.5"
        />
        <rect
          x="8.35004"
          y="0.25"
          width="5.5"
          height="19.5"
          rx="1.75"
          fill="white"
          stroke="#999999"
          stroke-width="0.5"
        />
        <rect x="16.35" y="0.25" width="5.5" height="19.5" rx="1.75" fill="white" stroke="#999999" stroke-width="0.5" />
      </svg>
    `;
  },

  view4: function(html) {
    return html`
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
          x="0.350098"
          y="0.25"
          width="8.5"
          height="8.5"
          rx="0.75"
          fill="white"
          stroke="#999999"
          stroke-width="0.5"
        />
        <rect x="11.35" y="0.25" width="8.5" height="8.5" rx="0.75" fill="white" stroke="#999999" stroke-width="0.5" />
        <rect
          x="0.350037"
          y="11.25"
          width="8.5"
          height="8.5"
          rx="0.75"
          fill="white"
          stroke="#999999"
          stroke-width="0.5"
        />
        <rect
          x="11.3499"
          y="11.25"
          width="8.5"
          height="8.5"
          rx="0.75"
          fill="white"
          stroke="#999999"
          stroke-width="0.5"
        />
      </svg>
    `;
  },
  checkmark: function(html) {
    return html`
      <svg
        aria-hidden="true"
        focusable="false"
        role="presentation"
        class="icon icon-checkmark"
        viewBox="0 0 130.2 130.2"
      >
        <path
          class="path"
          fill="none"
          stroke="#fff"
          stroke-width="13"
          stroke-linecap="square"
          stroke-miterlimit="10"
          d="M100.2 40.2L51.5 88.8 29.8 67.5"
        />
      </svg>
    `;
  },
  plus: function(html) {
    return html`
      <svg
        width="16"
        height="16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        class="icon icon-plus"
      >
        <path
          d="M8 3.333v9.334M3.333 8h9.334"
          stroke="currentColor"
          stroke-linecap="round"
          vector-effect="non-scaling-stroke"
        />
      </svg>
    `;
  },
  minus: function(html) {
    return html`
      <svg
        width="16"
        height="16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        class="icon icon-minus"
      >
        <path d="M3.333 8h9.334" stroke="currentColor" stroke-linecap="round" vector-effect="non-scaling-stroke" />
      </svg>
    `;
  },
  closeShowVariants: function(html) {
    return html`
      <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path id="close" d="M1.6129 0.234883C1.29972 -0.0782944 0.791957 -0.0782944 0.47878 0.234883C0.165602 0.548061 0.165602 1.05582 0.47878 1.369L5.10978 6L0.478828 10.631C0.16565 10.9441 0.16565 11.4519 0.478828 11.7651C0.792005 12.0782 1.29977 12.0782 1.61294 11.7651L6.2439 7.13412L10.8748 11.7651C11.188 12.0782 11.6958 12.0782 12.009 11.7651C12.3221 11.4519 12.3221 10.9441 12.009 10.631L7.37801 6L12.009 1.369C12.3222 1.05582 12.3222 0.548061 12.009 0.234883C11.6958 -0.0782944 11.1881 -0.0782944 10.8749 0.234883L6.2439 4.86588L1.6129 0.234883Z" fill="#999999"/>
      </svg>`
  },
  close: function(html) {
    return html`
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path id="close" d="M1.369 0.234883C1.05582 -0.0782944 0.548061 -0.0782944 0.234883 0.234883C-0.0782944 0.548061 -0.0782944 1.05582 0.234883 1.369L4.86588 6L0.234931 10.631C-0.0782463 10.9441 -0.0782466 11.4519 0.234931 11.7651C0.548109 12.0782 1.05587 12.0782 1.36905 11.7651L6 7.13412L10.631 11.7651C10.9441 12.0782 11.4519 12.0782 11.7651 11.7651C12.0782 11.4519 12.0782 10.9441 11.7651 10.631L7.13412 6L11.7651 1.369C12.0783 1.05582 12.0783 0.548061 11.7651 0.234883C11.4519 -0.0782944 10.9442 -0.0782944 10.631 0.234883L6 4.86588L1.369 0.234883Z" fill="#333333"/>
      </svg>`
  },
  closeIcon: function(html) {
    return html`<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path id="Exclude" fill-rule="evenodd" clip-rule="evenodd" d="M6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0ZM8.39406 3.76859C8.59945 3.98896 8.58731 4.33411 8.36694 4.5395L6.77087 6.02708L8.25845 7.62315C8.46384 7.84352 8.45169 8.18867 8.23132 8.39406C8.01095 8.59945 7.6658 8.58731 7.46041 8.36694L5.97283 6.77087L4.37676 8.25845C4.15639 8.46384 3.81124 8.45169 3.60585 8.23132C3.40046 8.01095 3.4126 7.6658 3.63297 7.46041L5.22904 5.97283L3.74146 4.37676C3.53607 4.15639 3.54822 3.81124 3.76859 3.60585C3.98896 3.40046 4.33411 3.4126 4.5395 3.63297L6.02708 5.22904L7.62315 3.74146C7.84352 3.53607 8.18867 3.54822 8.39406 3.76859Z" fill="#333333"/></svg>`;
  },
  sortBy: function(html) {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="6" viewBox="0 0 14 6" fill="none">
        <path d="M2.1 0.107664L0.875 0.10769L6.99999 5.89242L13.125 0.107714L11.9 0.107688L7.00001 0.107714L2.1 0.107664Z" fill="#333333"/>
      </svg>`
  },
  openQuickview: function(html) {
    return html`
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.25" y="0.251465" width="31.5" height="31.4986" rx="15.7493" fill="white" fill-opacity="0.5"/>
        <rect x="0.25" y="0.251465" width="31.5" height="31.4986" rx="15.7493" stroke="#333333" stroke-width="0.5"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M21.8307 13.3455C22.8662 14.4253 23.5724 15.6147 23.9331 16.4919C24.0223 16.7091 24.0223 16.9505 23.9331 17.1677C23.5277 18.1491 22.6521 19.5569 21.355 20.7797C20.0497 21.9864 18.2498 23.0001 16.0041 23.0001C13.7583 23.0001 11.9584 21.9864 10.6532 20.7797C9.34786 19.565 8.48036 18.1491 8.06689 17.1677C7.9777 16.9505 7.9777 16.7091 8.06689 16.4919C8.42022 15.6326 9.11103 14.4795 10.114 13.4143L9.34759 12.7784C9.10163 12.5743 9.06746 12.2107 9.27125 11.9663C9.47504 11.722 9.83963 11.6893 10.0856 11.8934L10.9534 12.6134C11.4637 12.1792 12.0411 11.7798 12.6834 11.4568L12.0808 10.4252C11.9199 10.1499 12.0128 9.79624 12.2881 9.63539C12.5635 9.47454 12.9171 9.56737 13.078 9.84273L13.7615 11.013C14.2023 10.8702 14.6675 10.7654 15.1565 10.7085L15.1565 9.57889C15.1565 9.25999 15.415 9.00146 15.7339 9.00146C16.0528 9.00146 16.3113 9.25999 16.3113 9.57889V10.6659C16.7738 10.6851 17.2166 10.7473 17.6393 10.8448L18.2168 9.84513C18.3763 9.569 18.7295 9.47447 19.0056 9.634C19.2818 9.79352 19.3763 10.1467 19.2168 10.4228L18.7662 11.2028C19.604 11.5444 20.3442 12.0203 20.9821 12.5523L21.7762 11.8934C22.0222 11.6893 22.3868 11.722 22.5906 11.9664C22.7944 12.2108 22.7602 12.5743 22.5142 12.7784L21.8307 13.3455ZM20.4469 19.8144C19.3038 20.8682 17.812 21.6807 16.0041 21.6807C14.1961 21.6807 12.7043 20.8682 11.5612 19.8144C10.491 18.8249 9.75323 17.6584 9.37218 16.8298C9.75323 15.9771 10.491 14.8347 11.5612 13.8452C12.7043 12.7914 14.1961 11.9789 16.0041 11.9789C17.812 11.9789 19.3038 12.7914 20.4469 13.8452C21.5171 14.8347 22.2306 15.9771 22.6359 16.8298C22.2306 17.6584 21.5171 18.8249 20.4469 19.8144ZM16.0035 19.4765C17.4767 19.4765 18.6709 18.2916 18.6709 16.8298C18.6709 15.3681 17.4767 14.1831 16.0035 14.1831C14.5304 14.1831 13.3362 15.3681 13.3362 16.8298C13.3362 18.2916 14.5304 19.4765 16.0035 19.4765Z" fill="#333333"/>
      </svg>
    `
  },
  openFilter: function(html) {
    return html`
      <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.62197 3.14282H11.25C11.6642 3.14282 12 3.47861 12 3.89282C12 4.30704 11.6642 4.64282 11.25 4.64282H6.62197C6.31309 5.51672 5.47966 6.14282 4.5 6.14282C3.52034 6.14282 2.68691 5.51672 2.37803 4.64282H0.75C0.335786 4.64282 0 4.30704 0 3.89282C0 3.47861 0.335786 3.14282 0.75 3.14282H2.37803C2.68691 2.26893 3.52034 1.64282 4.5 1.64282C5.47966 1.64282 6.31309 2.26893 6.62197 3.14282ZM3.20067 4.64282C3.19398 4.63125 3.18743 4.61958 3.18104 4.60781C3.06558 4.39527 3 4.15171 3 3.89282C3 3.61961 3.07305 3.36345 3.20067 3.14282C3.46003 2.69447 3.94479 2.39282 4.5 2.39282C5.05521 2.39282 5.53997 2.69447 5.79933 3.14282C5.80602 3.1544 5.81257 3.16607 5.81896 3.17783C5.93442 3.39037 6 3.63394 6 3.89282C6 4.16604 5.92695 4.42219 5.79933 4.64282C5.53997 5.09117 5.05521 5.39282 4.5 5.39282C3.94479 5.39282 3.46003 5.09117 3.20067 4.64282Z" fill="#333333"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.37803 9.35706H0.75C0.335787 9.35706 0 9.69284 0 10.1071C0 10.5213 0.335787 10.8571 0.75 10.8571H5.37803C5.68691 11.7309 6.52034 12.3571 7.5 12.3571C8.47966 12.3571 9.31309 11.7309 9.62197 10.8571H11.25C11.6642 10.8571 12 10.5213 12 10.1071C12 9.69284 11.6642 9.35706 11.25 9.35706H9.62197C9.31309 8.48316 8.47966 7.85706 7.5 7.85706C6.52034 7.85706 5.68691 8.48316 5.37803 9.35706ZM8.79933 10.8571C8.80602 10.8455 8.81257 10.8338 8.81896 10.822C8.93442 10.6095 9 10.3659 9 10.1071C9 9.83384 8.92695 9.57769 8.79933 9.35706C8.53997 8.9087 8.05521 8.60706 7.5 8.60706C6.94479 8.60706 6.46003 8.9087 6.20067 9.35706C6.19398 9.36863 6.18743 9.3803 6.18104 9.39207C6.06558 9.60461 6 9.84817 6 10.1071C6 10.3803 6.07305 10.6364 6.20067 10.8571C6.46003 11.3054 6.94479 11.6071 7.5 11.6071C8.05521 11.6071 8.53997 11.3054 8.79933 10.8571Z" fill="#333333"/>
      </svg>`
  },
  toggleFilter: function(html) {
    return html`
      <svg
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
        role="presentation"
        class="icon icon-filter"
        fill="none"
        viewBox="0 11 20 20"
        tabindex="-1"
      >
        <line x1="16.5" y1="17.5" x2="3.5" y2="17.5" stroke="#3F7972" stroke-linecap="round" />
        <line x1="16.5" y1="24.5" x2="3.5" y2="24.5" stroke="#3F7972" stroke-linecap="round" />
        <circle cx="13" cy="24.5" r="2" fill="white" stroke="#3F7972" />
        <circle cx="7" cy="17.5" r="2" fill="white" stroke="#3F7972" />
      </svg>
    `;
  },
  clearFilters: function(html) {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9">
        <path
          fill="#333"
          d="M4.5,143.621915 L8.12191516,140 L9,140.878085 L5.37808484,144.5 L9,148.121915 L8.12191516,149 L4.5,145.378085 L0.878084836,149 L-5.68434189e-13,148.121915 L3.62191516,144.5 L-5.68434189e-13,140.878085 L0.878084836,140 L4.5,143.621915 Z"
          transform="translate(0 -140)"
        />
      </svg>
    `;
  },
  cart: function(html) {
    return html`
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.25" y="0.25" width="31.5" height="31.5" rx="15.75" fill="white" fill-opacity="0.5" />
        <rect x="0.25" y="0.25" width="31.5" height="31.5" rx="15.75" stroke="#999999" stroke-width="0.5" />
        <g clip-path="url(#clip0_750_7208)">
          <path
            d="M22.6755 11.5823C22.5551 11.4619 22.382 11.3866 22.2089 11.3866H19.477C19.4544 10.4911 19.0932 9.65569 18.461 9.01599C17.8288 8.37629 16.9332 8 16 8C15.0668 8 14.1938 8.36124 13.5391 9.01599C12.9069 9.64817 12.5457 10.4911 12.5231 11.3866H9.79118C9.61809 11.3866 9.45252 11.4544 9.32458 11.5823C9.19664 11.7103 9.12891 11.8758 9.12891 12.0489V23.3377C9.12891 23.5108 9.19664 23.6839 9.32458 23.8043C9.45252 23.9247 9.61056 24 9.79118 24H22.2089C22.382 24 22.5551 23.9323 22.6755 23.8043C22.7959 23.6764 22.8711 23.5108 22.8711 23.3377V12.0489C22.8711 11.8758 22.8034 11.7027 22.6755 11.5823ZM21.5541 19.2888H10.4535V12.7037H12.5231V14.2992C12.5231 14.4722 12.5908 14.6453 12.7187 14.7658C12.8467 14.8862 13.0047 14.9614 13.1854 14.9614H13.8476V12.7037H18.175V14.9614H18.8373C19.0104 14.9614 19.1835 14.8937 19.3039 14.7658C19.4243 14.6378 19.4996 14.4722 19.4996 14.2992V12.7037H21.5692V19.2888H21.5541ZM10.4535 20.6058H21.5541V22.6754H10.4535V20.6058ZM13.8401 11.3866C13.8627 10.8448 14.0885 10.3405 14.4723 9.9492C14.8787 9.5428 15.4281 9.31703 16 9.31703C16.572 9.31703 17.1214 9.5428 17.5278 9.9492C17.9116 10.333 18.1374 10.8523 18.16 11.3866H13.8401Z"
            fill="#333333"
          />
        </g>
        <defs>
          <clipPath id="clip0_750_7208">
            <rect width="13.7422" height="16" fill="white" transform="translate(9.12891 8)" />
          </clipPath>
        </defs>
      </svg>
    `;
  },
  addToCart: function(html) {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none">
        <g clip-path="url(#clip0_399_21395)">
          <path
            d="M0.442217 5.77556H12.3578V14.2311C12.3578 14.9638 11.7638 15.5578 11.0311 15.5578H1.76887C1.03618 15.5578 0.442217 14.9638 0.442217 14.2311V5.77556Z"
            stroke="#4D4D4D"
            stroke-width="0.884434"
          />
          <path
            d="M3.83984 8.53334V2.89183C3.83984 1.58927 4.89578 0.53334 6.19833 0.53334H6.60135C7.90391 0.53334 8.95984 1.58927 8.95984 2.89183V8.53334"
            stroke="#4D4D4D"
            stroke-width="0.884434"
          />
        </g>
        <defs>
          <clipPath id="clip0_399_21395">
            <rect width="12.8" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    `;
  },
  addToCartVariants: function(html) {
    return html`
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12 15.75H6C3.92925 15.75 2.25 14.0707 2.25 12V6.47549C2.25 6.06149 2.586 5.72549 3 5.72549H15C15.414 5.72549 15.75 6.06149 15.75 6.47549V12C15.75 14.0707 14.0707 15.75 12 15.75Z"
          stroke="#111111"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 8.25V3.75C12 2.92125 11.3288 2.25 10.5 2.25H7.5C6.67125 2.25 6 2.92125 6 3.75V8.25"
          stroke="#111111"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    `;
  },
  placeholderProductCard: function(html) {
    return html`
      <svg width="310" height="500" viewBox="0 0 310 500" fill="none" xmlns="http://www.w3.org/2000/svg" style="width: 100%;height: auto;">
        <rect width="310" height="398" fill="#DDE1E6"></rect>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M150 194C148.343 194 147 195.343 147 197C147 198.657 148.343 200 150 200C151.657 200 153 198.657 153 197C153 195.343 151.657 194 150 194ZM149 197C149 196.448 149.448 196 150 196C150.552 196 151 196.448 151 197C151 197.552 150.552 198 150 198C149.448 198 149 197.552 149 197Z" fill="white"></path>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M146 190C144.343 190 143 191.343 143 193V205C143 206.657 144.343 208 146 208H164C165.657 208 167 206.657 167 205V193C167 191.343 165.657 190 164 190H146ZM164 192H146C145.448 192 145 192.448 145 193V205C145 205.552 145.448 206 146 206H150.314L157.192 199.121C158.364 197.95 160.263 197.95 161.435 199.121L165 202.686V193C165 192.448 164.552 192 164 192ZM164 206H153.142L158.607 200.536C158.997 200.145 159.63 200.145 160.021 200.536L164.907 205.422C164.748 205.763 164.402 206 164 206Z" fill="white"></path>
        <rect width="101" height="20" transform="translate(0 402)" fill="#DDE1E6"></rect>
        <path d="M3.65438 414.52L2.73038 411.958C2.61371 412.005 2.30758 412.109 1.73638 412.322C1.00839 412.616 1.03408 413.134 1.06438 413.288C1.10639 413.666 1.49839 414.591 1.68038 414.758C1.92386 414.982 2.45971 414.94 2.67438 414.87L3.65438 414.52Z" fill="#DDE1E6"></path>
        <path d="M4.08839 414.352L3.16439 411.79C4.48599 411.297 5.92706 409.877 6.48239 409.228C6.94906 410.525 7.96359 413.333 8.28839 414.184C6.58599 413.87 4.77906 414.165 4.08839 414.352Z" fill="#DDE1E6"></path>
        <path d="M4.36839 414.73L3.08039 415.192C3.47239 415.57 4.30679 416.379 4.50839 416.592C4.71839 416.858 4.99839 416.886 5.18039 416.774C5.39319 416.617 5.34372 416.363 5.29239 416.256L4.36839 414.73Z" fill="#DDE1E6"></path>
        <path d="M7.08439 408.248C6.75959 408.36 6.76239 408.687 6.80439 408.836C7.42972 410.549 8.70279 414.041 8.79239 414.31C8.89039 414.52 9.19839 414.632 9.40839 414.534C9.65479 414.422 9.68839 414.151 9.67439 414.03C9.06772 412.369 7.81519 408.94 7.65839 408.514C7.57439 408.304 7.32239 408.164 7.08439 408.248Z" fill="#DDE1E6"></path>
        <path d="M11.0419 407.247C11.1469 407.023 11.0489 406.75 10.8319 406.645C10.6149 406.54 10.3349 406.645 10.2299 406.862L9.64193 408.094C9.53693 408.318 9.63493 408.584 9.85193 408.696C10.0689 408.808 10.3489 408.71 10.4539 408.486L11.0419 407.254V407.247Z" fill="#DDE1E6"></path>
        <path d="M11.4761 409.613C11.2451 409.697 11.1261 409.956 11.2031 410.187C11.2801 410.418 11.5461 410.544 11.7771 410.46L13.0441 410.005C13.2751 409.928 13.4011 409.662 13.3171 409.431C13.2331 409.207 12.9741 409.081 12.7431 409.158L11.4691 409.606L11.4761 409.613Z" fill="#DDE1E6"></path>
        <path d="M12.5401 413.386C12.7641 413.491 13.0371 413.393 13.1421 413.176C13.2471 412.959 13.1421 412.679 12.9251 412.574L11.6931 411.986C11.4691 411.881 11.1961 411.972 11.0911 412.196C10.9861 412.42 11.0841 412.693 11.3011 412.798L12.5331 413.386H12.5401Z" fill="#DDE1E6"></path>
        <path d="M24.0762 409.236H20.4492V411.41H23.9707V412.693H20.4492V415.717H24.0762V417H19.084V407.953H24.0762V409.236ZM25.6172 411.293H26.9414V411.82C27.4023 411.363 27.9219 411.135 28.5 411.135C29.1641 411.135 29.6816 411.344 30.0527 411.762C30.373 412.117 30.5332 412.697 30.5332 413.502V417H29.209V413.812C29.209 413.25 29.1309 412.861 28.9746 412.646C28.8223 412.428 28.5449 412.318 28.1426 412.318C27.7051 412.318 27.3945 412.463 27.2109 412.752C27.0312 413.037 26.9414 413.535 26.9414 414.246V417H25.6172V411.293ZM33.5215 411.293V420.105H32.2031V411.293H33.5215ZM32.0039 408.92C32.0039 408.689 32.0879 408.49 32.2559 408.322C32.4238 408.154 32.625 408.07 32.8594 408.07C33.0977 408.07 33.3008 408.154 33.4688 408.322C33.6367 408.486 33.7207 408.688 33.7207 408.926C33.7207 409.164 33.6367 409.367 33.4688 409.535C33.3047 409.703 33.1035 409.787 32.8652 409.787C32.627 409.787 32.4238 409.703 32.2559 409.535C32.0879 409.367 32.0039 409.162 32.0039 408.92ZM34.9219 414.105C34.9219 413.281 35.2168 412.58 35.8066 412.002C36.3965 411.424 37.1152 411.135 37.9629 411.135C38.8145 411.135 39.5371 411.426 40.1309 412.008C40.7168 412.59 41.0098 413.305 41.0098 414.152C41.0098 415.008 40.7148 415.725 40.125 416.303C39.5312 416.877 38.8027 417.164 37.9395 417.164C37.084 417.164 36.3672 416.871 35.7891 416.285C35.2109 415.707 34.9219 414.98 34.9219 414.105ZM36.2695 414.129C36.2695 414.699 36.4219 415.15 36.7266 415.482C37.0391 415.818 37.4512 415.986 37.9629 415.986C38.4785 415.986 38.8906 415.82 39.1992 415.488C39.5078 415.156 39.6621 414.713 39.6621 414.158C39.6621 413.604 39.5078 413.16 39.1992 412.828C38.8867 412.492 38.4746 412.324 37.9629 412.324C37.459 412.324 37.0508 412.492 36.7383 412.828C36.4258 413.164 36.2695 413.598 36.2695 414.129ZM43.9277 415.939L41.3613 411.293H42.8906L44.6367 414.574L46.2656 411.293H47.7539L43.207 420.105H41.7012L43.9277 415.939ZM54.5332 415.717H57.9023V417H51.8262L54.9668 413.197C55.2754 412.818 55.5332 412.49 55.7402 412.213C55.9512 411.936 56.1113 411.703 56.2207 411.516C56.4434 411.148 56.5547 410.818 56.5547 410.525C56.5547 410.104 56.4062 409.75 56.1094 409.465C55.8125 409.18 55.4453 409.037 55.0078 409.037C54.0938 409.037 53.5703 409.578 53.4375 410.66H52.0781C52.2969 408.754 53.2598 407.801 54.9668 407.801C55.791 407.801 56.4824 408.062 57.041 408.586C57.6035 409.109 57.8848 409.758 57.8848 410.531C57.8848 411.023 57.7539 411.506 57.4922 411.979C57.3594 412.225 57.1641 412.518 56.9062 412.857C56.6523 413.193 56.3301 413.592 55.9395 414.053L54.5332 415.717ZM64.834 412.523V417H63.5098V412.523H63.041V411.293H63.5098V409.09C63.5098 408.371 63.6348 407.863 63.8848 407.566C64.2285 407.152 64.7285 406.945 65.3848 406.945C65.6191 406.945 65.9141 407.014 66.2695 407.15V408.498L66.1348 408.428C65.8496 408.283 65.6152 408.211 65.4316 408.211C65.1973 408.211 65.0391 408.295 64.957 408.463C64.875 408.627 64.834 408.943 64.834 409.412V411.293H66.2695V412.523H64.834ZM66.9141 414.105C66.9141 413.281 67.209 412.58 67.7988 412.002C68.3887 411.424 69.1074 411.135 69.9551 411.135C70.8066 411.135 71.5293 411.426 72.123 412.008C72.709 412.59 73.002 413.305 73.002 414.152C73.002 415.008 72.707 415.725 72.1172 416.303C71.5234 416.877 70.7949 417.164 69.9316 417.164C69.0762 417.164 68.3594 416.871 67.7812 416.285C67.2031 415.707 66.9141 414.98 66.9141 414.105ZM68.2617 414.129C68.2617 414.699 68.4141 415.15 68.7188 415.482C69.0312 415.818 69.4434 415.986 69.9551 415.986C70.4707 415.986 70.8828 415.82 71.1914 415.488C71.5 415.156 71.6543 414.713 71.6543 414.158C71.6543 413.604 71.5 413.16 71.1914 412.828C70.8789 412.492 70.4668 412.324 69.9551 412.324C69.4512 412.324 69.043 412.492 68.7305 412.828C68.418 413.164 68.2617 413.598 68.2617 414.129ZM74.4023 411.293H75.7207V411.803C75.9629 411.549 76.1777 411.375 76.3652 411.281C76.5566 411.184 76.7832 411.135 77.0449 411.135C77.3926 411.135 77.7559 411.248 78.1348 411.475L77.5312 412.682C77.2812 412.502 77.0371 412.412 76.7988 412.412C76.0801 412.412 75.7207 412.955 75.7207 414.041V417H74.4023V411.293ZM84.3738 406.802V407.491C84.6504 407.536 84.8766 407.627 85.0523 407.765C85.2281 407.904 85.3957 408.116 85.5551 408.402L84.8695 408.785C84.6633 408.41 84.3938 408.222 84.0609 408.222C83.8547 408.222 83.6836 408.283 83.5477 408.405C83.4117 408.527 83.3438 408.679 83.3438 408.862C83.3438 409.029 83.3988 409.167 83.509 409.277C83.6168 409.385 83.8348 409.512 84.1629 409.66C84.4465 409.789 84.6809 409.911 84.866 410.026C85.0512 410.138 85.1906 410.247 85.2844 410.353C85.5492 410.639 85.6816 410.984 85.6816 411.39C85.6816 411.788 85.5621 412.14 85.323 412.445C85.0863 412.747 84.7699 412.951 84.3738 413.056V413.784H83.7586V413.077C83.2992 413.002 82.9488 412.844 82.7074 412.603C82.466 412.361 82.2879 411.989 82.173 411.485L82.9465 411.323C83.052 411.679 83.1809 411.934 83.3332 412.086C83.4926 412.231 83.7047 412.304 83.9695 412.304C84.2273 412.304 84.443 412.221 84.6164 412.054C84.7875 411.89 84.873 411.678 84.873 411.418C84.873 411.186 84.8016 411 84.6586 410.859C84.5859 410.791 84.4781 410.715 84.3352 410.63C84.1945 410.544 84.0141 410.45 83.7938 410.349C83.3391 410.145 83.0402 409.958 82.8973 409.787C82.6699 409.531 82.5563 409.225 82.5563 408.869C82.5563 408.7 82.5832 408.543 82.6371 408.398C82.691 408.253 82.7684 408.121 82.8691 408.004C82.9723 407.885 83.0988 407.782 83.2488 407.695C83.3988 407.608 83.5688 407.54 83.7586 407.491V406.802H84.3738ZM89.6734 409.23H88.109L88.859 407.953H91.0387V417H89.6734V409.23ZM99.189 409.23H96.4L95.9547 410.73C96.0211 410.723 96.0836 410.717 96.1422 410.713C96.2047 410.709 96.2613 410.707 96.3121 410.707C97.191 410.707 97.9117 411.004 98.4742 411.598C99.0406 412.188 99.3238 412.943 99.3238 413.865C99.3238 414.818 99.0035 415.604 98.3629 416.221C97.7223 416.838 96.9156 417.146 95.943 417.146C94.7437 417.146 93.7984 416.584 93.107 415.459L94.1383 414.586C94.4234 415.07 94.7105 415.412 94.9996 415.611C95.2887 415.807 95.6422 415.904 96.0601 415.904C96.607 415.904 97.066 415.713 97.4371 415.33C97.8082 414.936 97.9937 414.457 97.9937 413.895C97.9937 413.316 97.8101 412.844 97.443 412.477C97.0758 412.098 96.6168 411.908 96.066 411.908C95.4527 411.908 94.9234 412.176 94.4781 412.711H94.0269L95.4508 407.953H99.189V409.23Z" fill="#DDE1E6"></path>
        <rect width="310" height="32" transform="translate(0 426)" fill="#DDE1E6"></rect>
        <rect width="45" height="20" transform="translate(0 462)" fill="#DDE1E6"></rect>
        <path d="M2.9904 469.11V471.362C3.5196 471.185 3.8472 470.715 3.8472 470.16C3.8472 469.623 3.4272 469.32 2.9904 469.11ZM2.436 468.111V466.271C1.9908 466.355 1.6548 466.758 1.6548 467.22C1.6548 467.682 2.0664 467.943 2.436 468.111ZM2.436 471.42V468.858C1.6716 468.539 0.9492 468.128 0.9492 467.195C0.9492 466.322 1.6044 465.725 2.436 465.608V464.742H2.9904V465.608C3.5616 465.683 4.0656 466.061 4.3176 466.565L3.7632 466.926C3.5952 466.632 3.3432 466.347 2.9904 466.28V468.354C3.822 468.707 4.5528 469.136 4.5528 470.144C4.5528 471.076 3.8976 471.857 2.9904 472.042V472.966H2.436V472.092C1.5288 472.05 0.7812 471.345 0.6216 470.463L1.302 470.27C1.3776 470.849 1.8396 471.378 2.436 471.42ZM9.22217 472.002V470.91C10.3422 470.868 11.3082 470.532 11.3082 469.202C11.3082 468.082 10.5662 467.354 9.46017 467.354C8.41017 467.354 7.82217 468.054 7.72417 469.048H6.56217C6.73017 467.368 7.75217 466.262 9.48817 466.262C11.1822 466.262 12.4842 467.41 12.4842 469.146C12.4842 470.084 11.9802 471.022 11.1262 471.456C12.1482 471.918 12.6382 472.968 12.6382 474.046C12.6382 475.894 11.1682 477.182 9.36217 477.182C7.65417 477.182 6.25417 476.02 6.22617 474.256H7.37417C7.43017 475.334 8.34017 476.09 9.40417 476.09C10.5802 476.09 11.4622 475.138 11.4622 473.976C11.4622 472.632 10.5102 471.96 9.22217 472.002ZM17.4851 477.182L16.6031 476.58L19.0391 473.234L19.0111 473.206C18.7311 473.29 18.4231 473.346 18.1011 473.346C16.1691 473.346 14.6851 471.778 14.6851 469.86C14.6851 467.858 16.3371 466.262 18.3251 466.262C20.3131 466.262 21.9651 467.858 21.9651 469.86C21.9651 470.812 21.5311 471.638 20.9851 472.394L17.4851 477.182ZM18.3251 467.354C16.9531 467.354 15.8611 468.46 15.8611 469.818C15.8611 471.19 16.9531 472.254 18.3251 472.254C19.6831 472.254 20.7891 471.19 20.7891 469.818C20.7891 468.46 19.6831 467.354 18.3251 467.354ZM24.8381 475.614C25.2721 475.614 25.6221 475.964 25.6221 476.384C25.6221 476.818 25.2721 477.182 24.8381 477.182C24.4041 477.182 24.0541 476.818 24.0541 476.384C24.0541 475.964 24.4041 475.614 24.8381 475.614ZM30.4187 477.182L29.5367 476.58L31.9727 473.234L31.9447 473.206C31.6647 473.29 31.3567 473.346 31.0347 473.346C29.1027 473.346 27.6187 471.778 27.6187 469.86C27.6187 467.858 29.2707 466.262 31.2587 466.262C33.2467 466.262 34.8987 467.858 34.8987 469.86C34.8987 470.812 34.4647 471.638 33.9187 472.394L30.4187 477.182ZM31.2587 467.354C29.8867 467.354 28.7947 468.46 28.7947 469.818C28.7947 471.19 29.8867 472.254 31.2587 472.254C32.6167 472.254 33.7227 471.19 33.7227 469.818C33.7227 468.46 32.6167 467.354 31.2587 467.354ZM39.0457 477.182L38.1637 476.58L40.5997 473.234L40.5717 473.206C40.2917 473.29 39.9837 473.346 39.6617 473.346C37.7297 473.346 36.2457 471.778 36.2457 469.86C36.2457 467.858 37.8977 466.262 39.8857 466.262C41.8737 466.262 43.5257 467.858 43.5257 469.86C43.5257 470.812 43.0917 471.638 42.5457 472.394L39.0457 477.182ZM39.8857 467.354C38.5137 467.354 37.4217 468.46 37.4217 469.818C37.4217 471.19 38.5137 472.254 39.8857 472.254C41.2437 472.254 42.3497 471.19 42.3497 469.818C42.3497 468.46 41.2437 467.354 39.8857 467.354Z" fill="#DDE1E6"></path>
        <rect width="113" height="14" transform="translate(0 486)" fill="#DDE1E6"></rect>
        <path d="M6.90767 486.222C6.94183 486.14 7.05817 486.14 7.09233 486.222L8.82807 490.395C8.84247 490.43 8.87503 490.453 8.91241 490.456L13.4177 490.818C13.5064 490.825 13.5424 490.935 13.4748 490.993L10.0422 493.934C10.0137 493.958 10.0013 493.996 10.01 494.033L11.0587 498.429C11.0793 498.516 10.9852 498.584 10.9093 498.538L7.05213 496.182C7.02012 496.162 6.97988 496.162 6.94787 496.182L3.09069 498.538C3.01478 498.584 2.92065 498.516 2.94129 498.429L3.99 494.033C3.9987 493.996 3.98626 493.958 3.95778 493.934L0.5252 490.993C0.457646 490.935 0.493599 490.825 0.582264 490.818L5.08759 490.456C5.12497 490.453 5.15753 490.43 5.17193 490.395L6.90767 486.222Z" fill="#DDE1E6"></path>
        <path d="M24.9077 486.222C24.9418 486.14 25.0582 486.14 25.0923 486.222L26.8281 490.395C26.8425 490.43 26.875 490.453 26.9124 490.456L31.4177 490.818C31.5064 490.825 31.5424 490.935 31.4748 490.993L28.0422 493.934C28.0137 493.958 28.0013 493.996 28.01 494.033L29.0587 498.429C29.0793 498.516 28.9852 498.584 28.9093 498.538L25.0521 496.182C25.0201 496.162 24.9799 496.162 24.9479 496.182L21.0907 498.538C21.0148 498.584 20.9207 498.516 20.9413 498.429L21.99 494.033C21.9987 493.996 21.9863 493.958 21.9578 493.934L18.5252 490.993C18.4576 490.935 18.4936 490.825 18.5823 490.818L23.0876 490.456C23.125 490.453 23.1575 490.43 23.1719 490.395L24.9077 486.222Z" fill="#DDE1E6"></path>
        <path d="M42.9077 486.222C42.9418 486.14 43.0582 486.14 43.0923 486.222L44.8281 490.395C44.8425 490.43 44.875 490.453 44.9124 490.456L49.4177 490.818C49.5064 490.825 49.5424 490.935 49.4748 490.993L46.0422 493.934C46.0137 493.958 46.0013 493.996 46.01 494.033L47.0587 498.429C47.0793 498.516 46.9852 498.584 46.9093 498.538L43.0521 496.182C43.0201 496.162 42.9799 496.162 42.9479 496.182L39.0907 498.538C39.0148 498.584 38.9207 498.516 38.9413 498.429L39.99 494.033C39.9987 493.996 39.9863 493.958 39.9578 493.934L36.5252 490.993C36.4576 490.935 36.4936 490.825 36.5823 490.818L41.0876 490.456C41.125 490.453 41.1575 490.43 41.1719 490.395L42.9077 486.222Z" fill="#DDE1E6"></path>
        <path d="M60.9077 486.222C60.9418 486.14 61.0582 486.14 61.0923 486.222L62.8281 490.395C62.8425 490.43 62.875 490.453 62.9124 490.456L67.4177 490.818C67.5064 490.825 67.5424 490.935 67.4748 490.993L64.0422 493.934C64.0137 493.958 64.0013 493.996 64.01 494.033L65.0587 498.429C65.0793 498.516 64.9852 498.584 64.9093 498.538L61.0521 496.182C61.0201 496.162 60.9799 496.162 60.9479 496.182L57.0907 498.538C57.0148 498.584 56.9207 498.516 56.9413 498.429L57.99 494.033C57.9987 493.996 57.9863 493.958 57.9578 493.934L54.5252 490.993C54.4576 490.935 54.4936 490.825 54.5823 490.818L59.0876 490.456C59.125 490.453 59.1575 490.43 59.1719 490.395L60.9077 486.222Z" fill="#DDE1E6"></path>
        <path d="M78.9077 486.222C78.9418 486.14 79.0582 486.14 79.0923 486.222L80.8281 490.395C80.8425 490.43 80.875 490.453 80.9124 490.456L85.4177 490.818C85.5064 490.825 85.5424 490.935 85.4748 490.993L82.0422 493.934C82.0137 493.958 82.0013 493.996 82.01 494.033L83.0587 498.429C83.0793 498.516 82.9852 498.584 82.9093 498.538L79.0521 496.182C79.0201 496.162 78.9799 496.162 78.9479 496.182L75.0907 498.538C75.0148 498.584 74.9207 498.516 74.9413 498.429L75.99 494.033C75.9987 493.996 75.9863 493.958 75.9578 493.934L72.5252 490.993C72.4576 490.935 72.4936 490.825 72.5823 490.818L77.0876 490.456C77.125 490.453 77.1575 490.43 77.1719 490.395L78.9077 486.222Z" fill="#DDE1E6"></path>
        <g clip-path="url(#clip0_1644_24858)">
        <path d="M93.932 487.292L94.82 487.952C94.064 489.536 93.788 491.552 93.788 493.304C93.788 495.056 94.064 497.072 94.82 498.656L93.932 499.316C93.044 497.576 92.684 495.236 92.684 493.304C92.684 491.36 93.044 489.02 93.932 487.292ZM101.84 488.984H98.9959L98.4319 490.844L99.0679 490.808C100.82 490.808 101.972 492.308 101.972 493.976C101.972 495.884 100.484 497.192 98.6239 497.192C97.5079 497.192 96.3919 496.604 95.8639 495.608L96.7039 494.816C96.9799 495.584 97.9039 496.16 98.7079 496.16C99.9319 496.16 100.892 495.152 100.892 493.94C100.892 492.776 99.8959 491.792 98.7319 491.792C98.0959 491.792 97.4359 492.092 97.0399 492.596H96.8239L98.2159 487.952H101.84V488.984ZM108.777 488.984H105.933L105.369 490.844L106.005 490.808C107.757 490.808 108.909 492.308 108.909 493.976C108.909 495.884 107.421 497.192 105.561 497.192C104.445 497.192 103.329 496.604 102.801 495.608L103.641 494.816C103.917 495.584 104.841 496.16 105.645 496.16C106.869 496.16 107.829 495.152 107.829 493.94C107.829 492.776 106.833 491.792 105.669 491.792C105.033 491.792 104.373 492.092 103.977 492.596H103.761L105.153 487.952H108.777V488.984ZM110.063 487.952L110.951 487.292C111.839 489.02 112.199 491.36 112.199 493.304C112.199 495.236 111.839 497.576 110.951 499.316L110.063 498.656C110.819 497.072 111.095 495.056 111.095 493.304C111.095 491.552 110.819 489.536 110.063 487.952Z" fill="#DDE1E6"></path>
        </g>
        <defs>
        <clipPath id="clip0_1644_24858">
        <rect x="92" y="486" width="21" height="14" rx="1" fill="white"></rect>
        </clipPath>
        </defs>
      </svg>
    `;
  },
  placeholderProductCardSmall: function(html) {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="169" height="309" viewBox="0 0 169 309" fill="none" style="width: 100%;height: auto;">
        <g clip-path="url(#clip0_1644_5762)">
          <rect width="169" height="216" fill="url(#pattern0_1644_5762)"></rect>
          <rect width="169" height="216" fill="#DDE1E6"></rect>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M79 103C77.3431 103 76 104.343 76 106C76 107.657 77.3431 109 79 109C80.6569 109 82 107.657 82 106C82 104.343 80.6569 103 79 103ZM78 106C78 105.448 78.4477 105 79 105C79.5523 105 80 105.448 80 106C80 106.552 79.5523 107 79 107C78.4477 107 78 106.552 78 106Z" fill="white"></path>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M75 99C73.3431 99 72 100.343 72 102V114C72 115.657 73.3431 117 75 117H93C94.6569 117 96 115.657 96 114V102C96 100.343 94.6569 99 93 99H75ZM93 101H75C74.4477 101 74 101.448 74 102V114C74 114.552 74.4477 115 75 115H79.3137L86.1924 108.121C87.364 106.95 89.2635 106.95 90.435 108.121L94 111.686V102C94 101.448 93.5523 101 93 101ZM93 115H82.1422L87.6066 109.536C87.9971 109.145 88.6303 109.145 89.0208 109.536L93.907 114.422C93.7479 114.763 93.4016 115 93 115Z" fill="white"></path>
        </g>
        <rect width="92" height="17" transform="translate(0 220)" fill="#DDE1E6"></rect>
        <rect width="169" height="32" transform="translate(0 241)" fill="#DDE1E6"></rect>
        <rect width="38" height="20" transform="translate(0 275)" fill="#DDE1E6"></rect>
        <rect width="100" height="12" transform="translate(0 297)" fill="#DDE1E6"></rect>
        <path d="M5.92086 297.19C5.95014 297.12 6.04986 297.12 6.07914 297.19L7.56691 300.767C7.57926 300.797 7.60717 300.817 7.63921 300.82L11.5009 301.129C11.5769 301.136 11.6077 301.23 11.5498 301.28L8.60761 303.8C8.5832 303.821 8.57254 303.854 8.58 303.885L9.4789 307.654C9.49658 307.728 9.41591 307.786 9.35084 307.747L6.04468 305.727C6.01725 305.711 5.98275 305.711 5.95532 305.727L2.64916 307.747C2.58409 307.786 2.50341 307.728 2.52111 307.654L3.42 303.885C3.42746 303.854 3.4168 303.821 3.39239 303.8L0.450172 301.28C0.392268 301.23 0.423085 301.136 0.499084 301.129L4.36079 300.82C4.39283 300.817 4.42074 300.797 4.43309 300.767L5.92086 297.19Z" fill="#DDE1E6"></path>
        <path d="M21.9209 297.19C21.9501 297.12 22.0499 297.12 22.0791 297.19L23.5669 300.767C23.5793 300.797 23.6072 300.817 23.6392 300.82L27.5009 301.129C27.5769 301.136 27.6077 301.23 27.5498 301.28L24.6076 303.8C24.5832 303.821 24.5725 303.854 24.58 303.885L25.4789 307.654C25.4966 307.728 25.4159 307.786 25.3508 307.747L22.0447 305.727C22.0172 305.711 21.9828 305.711 21.9553 305.727L18.6492 307.747C18.5841 307.786 18.5034 307.728 18.5211 307.654L19.42 303.885C19.4275 303.854 19.4168 303.821 19.3924 303.8L16.4502 301.28C16.3923 301.23 16.4231 301.136 16.4991 301.129L20.3608 300.82C20.3928 300.817 20.4207 300.797 20.4331 300.767L21.9209 297.19Z" fill="#DDE1E6"></path>
        <path d="M37.9209 297.19C37.9501 297.12 38.0499 297.12 38.0791 297.19L39.5669 300.767C39.5793 300.797 39.6072 300.817 39.6392 300.82L43.5009 301.129C43.5769 301.136 43.6077 301.23 43.5498 301.28L40.6076 303.8C40.5832 303.821 40.5725 303.854 40.58 303.885L41.4789 307.654C41.4966 307.728 41.4159 307.786 41.3508 307.747L38.0447 305.727C38.0172 305.711 37.9828 305.711 37.9553 305.727L34.6492 307.747C34.5841 307.786 34.5034 307.728 34.5211 307.654L35.42 303.885C35.4275 303.854 35.4168 303.821 35.3924 303.8L32.4502 301.28C32.3923 301.23 32.4231 301.136 32.4991 301.129L36.3608 300.82C36.3928 300.817 36.4207 300.797 36.4331 300.767L37.9209 297.19Z" fill="#DDE1E6"></path>
        <path d="M53.9209 297.19C53.9501 297.12 54.0499 297.12 54.0791 297.19L55.5669 300.767C55.5793 300.797 55.6072 300.817 55.6392 300.82L59.5009 301.129C59.5769 301.136 59.6077 301.23 59.5498 301.28L56.6076 303.8C56.5832 303.821 56.5725 303.854 56.58 303.885L57.4789 307.654C57.4966 307.728 57.4159 307.786 57.3508 307.747L54.0447 305.727C54.0172 305.711 53.9828 305.711 53.9553 305.727L50.6492 307.747C50.5841 307.786 50.5034 307.728 50.5211 307.654L51.42 303.885C51.4275 303.854 51.4168 303.821 51.3924 303.8L48.4502 301.28C48.3923 301.23 48.4231 301.136 48.4991 301.129L52.3608 300.82C52.3928 300.817 52.4207 300.797 52.4331 300.767L53.9209 297.19Z" fill="#DDE1E6"></path>
        <path d="M69.9209 297.19C69.9501 297.12 70.0499 297.12 70.0791 297.19L71.5669 300.767C71.5793 300.797 71.6072 300.817 71.6392 300.82L75.5009 301.129C75.5769 301.136 75.6077 301.23 75.5498 301.28L72.6076 303.8C72.5832 303.821 72.5725 303.854 72.58 303.885L73.4789 307.654C73.4966 307.728 73.4159 307.786 73.3508 307.747L70.0447 305.727C70.0172 305.711 69.9828 305.711 69.9553 305.727L66.6492 307.747C66.5841 307.786 66.5034 307.728 66.5211 307.654L67.42 303.885C67.4275 303.854 67.4168 303.821 67.3924 303.8L64.4502 301.28C64.3923 301.23 64.4231 301.136 64.4991 301.129L68.3608 300.82C68.3928 300.817 68.4207 300.797 68.4331 300.767L69.9209 297.19Z" fill="#DDE1E6"></path>
      </svg>`
  },
  plpPromoImage: function(html) {
    return html`
      <svg class="plp-promo-img" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M3.65389 9.52002L2.72989 6.95802C2.61322 7.00469 2.30709 7.10922 1.73589 7.32202C1.0079 7.61602 1.03359 8.13402 1.06389 8.28802C1.1059 8.66602 1.4979 9.59059 1.67989 9.75802C1.92337 9.98202 2.45922 9.94002 2.67389 9.87002L3.65389 9.52002Z" fill="currentColor"/>
        <path d="M4.0879 9.35202L3.1639 6.79002C4.4855 6.29722 5.92657 4.87669 6.4819 4.22802C6.94857 5.52535 7.9631 8.33282 8.2879 9.18402C6.5855 8.87042 4.77857 9.16535 4.0879 9.35202Z" fill="currentColor"/>
        <path d="M4.3679 9.73002L3.0799 10.192C3.4719 10.57 4.3063 11.3792 4.5079 11.592C4.7179 11.858 4.9979 11.886 5.1799 11.774C5.3927 11.6172 5.34324 11.3634 5.2919 11.256L4.3679 9.73002Z" fill="currentColor"/>
        <path d="M7.0839 3.24802C6.7591 3.36002 6.7619 3.68669 6.8039 3.83602C7.42924 5.54869 8.7023 9.04122 8.7919 9.31002C8.8899 9.52002 9.1979 9.63202 9.4079 9.53402C9.6543 9.42202 9.6879 9.15135 9.6739 9.03002C9.06724 7.36869 7.8147 3.93962 7.6579 3.51402C7.5739 3.30402 7.3219 3.16402 7.0839 3.24802Z" fill="currentColor"/>
        <path d="M11.0422 2.24694C11.1472 2.02294 11.0492 1.74994 10.8322 1.64494C10.6152 1.53994 10.3352 1.64494 10.2302 1.86194L9.64217 3.09394C9.53717 3.31794 9.63517 3.58394 9.85217 3.69594C10.0692 3.80794 10.3492 3.70994 10.4542 3.48594L11.0422 2.25394V2.24694Z" fill="currentColor"/>
        <path d="M11.4761 4.613C11.2451 4.697 11.1261 4.95599 11.2031 5.18699C11.2801 5.41799 11.5461 5.544 11.7771 5.46L13.0441 5.005C13.2751 4.928 13.4011 4.66199 13.3171 4.43099C13.2331 4.20699 12.9741 4.08099 12.7431 4.15799L11.4691 4.60599L11.4761 4.613Z" fill="currentColor"/>
        <path d="M12.5401 8.38602C12.7641 8.49102 13.0371 8.39302 13.1421 8.17602C13.2471 7.95902 13.1421 7.67902 12.9251 7.57402L11.6931 6.98602C11.4691 6.88102 11.1961 6.97202 11.0911 7.19602C10.9861 7.42002 11.0841 7.69302 11.3011 7.79802L12.5331 8.38602H12.5401Z" fill="currentColor"/>
      </svg>`
  },
  quickviewPromoImage: function(html) {
    return html`
      <svg class="quickview-promo-img" style="display:none;" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M0.912008 10.752C1.28001 11.776 2.00801 12.2 3.00001 11.984L4.68001 13.696C5.11201 14.136 5.53601 14.272 6.03201 14.096C6.67201 13.864 6.96801 13.232 6.56801 12.552L5.73601 11.152C6.97601 10.952 8.30401 10.952 9.60801 11.176C9.92001 11.568 10.416 11.704 10.944 11.52C11.608 11.28 11.896 10.648 11.656 9.98397L9.40001 3.79197C9.16001 3.12797 8.52801 2.83197 7.86401 3.07197C7.32801 3.26397 7.03201 3.71997 7.06401 4.23197C6.07201 5.43997 4.63201 6.52797 3.38401 7.13597L1.88801 7.67997C0.688008 8.11197 0.272008 8.97597 0.688008 10.136L0.912008 10.744V10.752ZM10.176 10.528L7.92001 4.33597C7.84801 4.12797 7.93601 3.93597 8.14401 3.86397C8.35201 3.79197 8.54401 3.87997 8.61601 4.08797L10.872 10.28C10.944 10.488 10.856 10.68 10.656 10.752C10.456 10.824 10.256 10.736 10.184 10.528H10.176ZM4.76001 10.52L3.79201 7.85597C5.16801 7.15997 6.38401 6.25597 7.33601 5.14397L9.21601 10.32C7.74401 10.072 6.24801 10.168 4.75201 10.52H4.76001ZM3.12801 11.088C2.36801 11.368 1.96001 11.192 1.69601 10.472L1.47201 9.86397C1.20801 9.14397 1.40801 8.75197 2.17601 8.47197L3.02401 8.16797L3.97601 10.792L3.12801 11.096V11.088ZM5.33601 13.216L3.82401 11.72L4.88801 11.336C4.88801 11.336 4.92001 11.336 4.93601 11.32L5.89601 12.912C6.02401 13.112 5.94401 13.296 5.76001 13.368C5.59201 13.424 5.48801 13.368 5.33601 13.216Z" fill="currentColor"/>
        <path d="M12.832 2.56805C12.952 2.31205 12.84 2.00005 12.592 1.88005C12.344 1.76005 12.024 1.88005 11.904 2.12805L11.232 3.53605C11.112 3.79205 11.224 4.09605 11.472 4.22405C11.72 4.35205 12.04 4.24005 12.16 3.98405L12.832 2.57605V2.56805Z" fill="currentColor"/>
        <path d="M13.328 5.27199C13.064 5.36799 12.928 5.66399 13.016 5.92799C13.104 6.19199 13.408 6.33599 13.672 6.23999L15.12 5.71999C15.384 5.63199 15.528 5.32799 15.432 5.06399C15.336 4.80799 15.04 4.66399 14.776 4.75199L13.32 5.26399L13.328 5.27199Z" fill="currentColor"/>
        <path d="M14.544 9.58402C14.8 9.70402 15.112 9.59202 15.232 9.34402C15.352 9.09602 15.232 8.77602 14.984 8.65602L13.576 7.98402C13.32 7.86402 13.008 7.96802 12.888 8.22402C12.768 8.48002 12.88 8.79202 13.128 8.91202L14.536 9.58402H14.544Z" fill="currentColor"/>
      </svg>
    `
  },
  hideFilter: function(html) {
    return html`
      <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="&#60;&#60;">
        <path id="Line 210" d="M6 0.75L1.5 6L6 11.25" stroke="#333333" stroke-width="1.125"/>
        <path id="Line 211" d="M9.60004 0.75L5.10004 6L9.60004 11.25" stroke="#333333" stroke-width="1.125"/>
        </g>
      </svg>
    `
  },
  showFilter: function(html) {
    return html`
      <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.72563 4.33331H13.125C13.6082 4.33331 14 4.72506 14 5.20831C14 5.69156 13.6082 6.08331 13.125 6.08331H7.72563C7.36528 7.10286 6.39294 7.83331 5.25 7.83331C4.10706 7.83331 3.13472 7.10286 2.77437 6.08331H0.875C0.391751 6.08331 0 5.69156 0 5.20831C0 4.72506 0.391751 4.33331 0.875 4.33331H2.77437C3.13472 3.31377 4.10706 2.58331 5.25 2.58331C6.39294 2.58331 7.36528 3.31377 7.72563 4.33331ZM3.73412 6.08331C3.72631 6.06981 3.71867 6.05619 3.71122 6.04247C3.57651 5.7945 3.5 5.51034 3.5 5.20831C3.5 4.88956 3.58522 4.59071 3.73412 4.33331C4.0367 3.81024 4.60225 3.45831 5.25 3.45831C5.89775 3.45831 6.4633 3.81024 6.76588 4.33331C6.77369 4.34682 6.78133 4.36043 6.78878 4.37416C6.92349 4.62212 7 4.90628 7 5.20831C7 5.52706 6.91478 5.82591 6.76588 6.08331C6.4633 6.60639 5.89775 6.95831 5.25 6.95831C4.60225 6.95831 4.0367 6.60639 3.73412 6.08331Z" fill="#333333"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.27437 11.9166H0.875C0.391751 11.9166 0 12.3084 0 12.7916C0 13.2749 0.391751 13.6666 0.875 13.6666H6.27437C6.63472 14.6862 7.60706 15.4166 8.75 15.4166C9.89294 15.4166 10.8653 14.6862 11.2256 13.6666H13.125C13.6083 13.6666 14 13.2749 14 12.7916C14 12.3084 13.6083 11.9166 13.125 11.9166H11.2256C10.8653 10.8971 9.89294 10.1666 8.75 10.1666C7.60706 10.1666 6.63472 10.8971 6.27437 11.9166ZM10.2659 11.9166C10.4148 12.174 10.5 12.4729 10.5 12.7916C10.5 13.0937 10.4235 13.3778 10.2888 13.6258C9.99244 14.1713 9.41447 14.5416 8.75 14.5416C8.10225 14.5416 7.5367 14.1897 7.23412 13.6666C7.09933 13.4336 7.01672 13.1666 7.00228 12.8817C7.00077 12.8519 7 12.8218 7 12.7916C7 12.4896 7.07651 12.2054 7.21122 11.9575C7.21867 11.9437 7.22631 11.9301 7.23412 11.9166C7.5367 11.3936 8.10225 11.0416 8.75 11.0416C9.39775 11.0416 9.9633 11.3935 10.2659 11.9166Z" fill="#333333"/>
      </svg>
    `
  },
  shoppingBag: function(html) {
    return html`
      <svg class="icon icon-shopping-bag" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <title>Open shopping bag</title>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M16 20.6644H8C5.239 20.6644 3 18.4652 3 15.7534V8.51857C3 7.9764 3.448 7.53638 4 7.53638H20C20.552 7.53638 21 7.9764 21 8.51857V15.7534C21 18.4652 18.761 20.6644 16 20.6644Z" stroke="#111111" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"></path>
        <path d="M16 10.8424V4.94925C16 3.86393 15.105 2.98486 14 2.98486H10C8.895 2.98486 8 3.86393 8 4.94925V10.8424" stroke="#111111" stroke-linecap="round" stroke-linejoin="round" vector-effect="non-scaling-stroke"></path>
      </svg>
    `
  },
  popularSearch: function(html) {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
        <path d="M7.90767 1.22199C7.94183 1.13986 8.05817 1.13986 8.09233 1.22199L9.82807 5.3952C9.84247 5.42982 9.87503 5.45348 9.91241 5.45648L14.4177 5.81767C14.5064 5.82478 14.5424 5.93543 14.4748 5.99329L11.0422 8.93367C11.0137 8.95806 11.0013 8.99634 11.01 9.03282L12.0587 13.4293C12.0793 13.5158 11.9852 13.5842 11.9093 13.5378L8.05213 11.1818C8.02012 11.1623 7.97988 11.1623 7.94787 11.1818L4.09069 13.5378C4.01478 13.5842 3.92065 13.5158 3.94129 13.4293L4.99 9.03282C4.9987 8.99634 4.98626 8.95806 4.95778 8.93367L1.5252 5.99329C1.45765 5.93543 1.4936 5.82478 1.58226 5.81767L6.08759 5.45648C6.12497 5.45348 6.15753 5.42982 6.17193 5.3952L7.90767 1.22199Z" fill="white" stroke="#4D4D4D" stroke-width="1.2"/>
      </svg>
    `
  },
  chevron: {
    up: function(html) {
      return html`
        <svg
          aria-hidden="true"
          focusable="false"
          role="presentation"
          viewBox="0 0 13 6"
          class="icon icon--wide icon-chevron-up-2"
        >
          <path fill="none" stroke="#333" d="M1 6l5.5-6L12 6"></path>
        </svg>
      `;
    },
    down: function(html) {
      return html`
        <svg
          aria-hidden="true"
          focusable="false"
          role="presentation"
          viewBox="0 0 10 4"
          class="icon icon--wide icon-chevron-down"
        >
          <path fill="none" stroke="#555" d="M9 0L5 4 1 0"></path>
        </svg>
      `;
    }
  }
};


window.renderHelpers = {
  productObj: function(html, args) {
    const product = args.props.product;
    return html`
      <div style="display:none;" data-product-json>
        ${JSON.stringify(product)}
      </div>`
  },
  productCard: {
    wishlistButton: function(html, args) {
      const product = args.props.product
      return html`
       <button
         data-product="${product.id}"
         data-product-title="${product.title}"
         data-variant="${product.variants[0].id}"
         aria-label="Add ${product.title} to wishlist"
         class="product-card__wishlist-icon smartwishlist"
       ></button>
      `;
    },
    images: function(html, args) {
      const product = args.props.product
      return product.images.length > 1 ?
      html`
        <div class="image_slider">
          <span class="primary-image">
            <div class="product-card__image--cover"></div>
            <img
              width="1006"
              height="1294"
              src="${product.images[0].src}"
              loading="lazy"
              class="component-image__image product-image"
              alt="${product.title}"
            />
          </span>
          <span class="secondary-image">
            <div class="product-card__image--cover"></div>
            <img
              width="1006"
              height="1294"
              src="${product.images[1].src}"
              loading="lazy"
              class="component-image__image"
              alt="${product.title}"
            />
          </span>
        </div>
      ` :
      html`
        <img
          width="1006"
          height="1294"
          src="${product.featured_image?.src}"
          loading="lazy"
          class="component-image__image"
          alt="${product.title}"
        />
      `
    },
    actions: function(html, args, additionalClass) {
      const product = args.props.product;
      return html`
        <div class="product-card__actions ${additionalClass}">
          <${
            args.templates.addToCartForm
          } product=${product} />
          <${
            args.templates.productObj
          } product=${product} />
        </div>
      `;
    },
    reviews: function(html, args){
      const product = args.props.product;
      if (
        typeof product.metafields.okendo == "undefined" ||
        typeof product.metafields.okendo.summaryData == "undefined" ||
        typeof product.metafields.okendo.StarRatingSnippet == "undefined"
      ) {
        return null;
      }
      var reviewCount = product.metafields.okendo.summaryData.value.reviewCount;
      var reviewCountStr = `<span class="reviews-count">(${reviewCount})</span>`;
      if (reviewCount == 0) {
        reviewCountStr = "";
      }
      var starRattingSnippet =
        product.metafields.okendo.StarRatingSnippet.value.replaceAll(
          ["#oke-star-"],
          "#lovisa-star-"
        ) + reviewCountStr;
      return html`<div class="pd-reviews-block" dangerouslySetInnerHTML=${{
        __html: starRattingSnippet,
      }}></div>`;
    },
  },
  filter: function(html, args) {
    var props = args.props;
    var helpers = props.helpers;
    var classes = ["collection__filter", "filter"];
    var isCollapseOpen = false;
    if (props.collapsible) {
      isCollapseOpen = helpers.isCollapsibleFilterExpanded(props.filter.id);
      if (isCollapseOpen) {
        classes.push("expanded");
      } else {
        classes.push("collapsed");
      }
    }
    var className = classes.join(" ");
    return html`
            <div class=${className} data-filter-id=${props.filter.id}>
              <${args.templates.filterHeader} filterHeading=${props.filter.label} filterId=${props.filter.id} />
              <${args.templates.filterItems} filter=${props.filter} />
            </div>
          `;
  },
  filterHeader: function(html, args) {
    var props = args.props;
    var helpers = props.helpers;
    var filterOptions = helpers.getTemplateOptions("filters");
    var showClearActionForIndividualFilters =
      filterOptions.showClearActionForIndividualFilters &&
      helpers.isFilterApplied(props.filterId);
    var toggleCollapsibleFilter = () => {
      helpers.toggleCollapsibleFilter(props.filterId);
    };
    var clearFilter = (event) => {
      event.stopPropagation();
      helpers.clearFilter(props.filterId);
      removeFilterDataLayerEvent(props, props.filterId);
    };
    return html`
            <button
              onClick=${
                filterOptions.collapsible
                  ? toggleCollapsibleFilter
                  : undefined
              }
              class="filter__label filter-header ${filterOptions.collapsible ? 'filter-header--toggle' : ''}"
            >
              <h3 class="filter-heading filter__button">
                ${props.filterHeading}
              </h3>
              <div class="filter-actions">
                ${
                  showClearActionForIndividualFilters
                    ? html`
                      <div onClick=${clearFilter} class="filter-action-clear">
                        ${args.labels.filters.clearIndividualFilter}
                      </div>
                    `
                    : ""
                }
                <span class="filter-action-toggle-collapse">
                  ${
                    filterOptions.collapsible
                      ? html`
                        ${window.tagalysIcon.chevron.down(html)}
                        ${window.tagalysIcon.chevron.up(html)}
                      `
                      : ""
                  }
                </span>
              </div>
            </button>
          `;
  },
  noResults: function(html, args) {
    var props = args.props;
    var helpers = props.helpers;
    return html`
            <div class="no-results page-width">
              <div class="no-results-heading tg-no-result-heading">
              ${
                typeof helpers.getQuery() === "undefined"
                  ? html`
                <div class="tg-no-result-key">View items we like</div>
                <span class="tg-no-result-subheading bottom">Looking for something? Try searching for an item to find your perfect match</span>
                `
                  : html`
                <span class="tg-no-result-subheading top">${
                  args.labels.searchResults.noResultsHeading.heading
                }</span>
                <div class="tg-no-result-key">${helpers.getQuery()}</div>
                <span class="tg-no-result-subheading bottom">
                  ${args.labels.searchResults.noResultsHeading.subHeading}
                </span>
                `
              }
              </div>
              <div class="tg-no-result-products-wrapper">
                <div class="tg-no-result-products-widget-wrapper">
                  <${args.templates.noResultsWidgets} />
                </div>
              </div>
            </div>
          `;
  },
  sortOptions: function(html, args) {
    const props = args.props;
    const helpers = props.helpers;

    var sortOptions = helpers.getSortOptions();
    var appliedSortOption = helpers.getAppliedSortOption();
    var plp_selector = "[data-widget=product-listing-page-container]";

    var applySortOption = (event) => {
      if( document.querySelector(plp_selector) ) document.querySelector(plp_selector).setAttribute('aria-busy', true)
      helpers.applySortOption(event.target.value);
      clickSortOptionDataLayerEvent(helpers);
    };

    return html`
            <div class="sort-options-container">
              <select name="sort-options" class="sort-options" data-lvtrack-entity="sort" value=${
                appliedSortOption.id
              } onchange=${applySortOption}>
                ${sortOptions.map((sortOption) => {
                  return html`
                    <option value=${sortOption.id}>${sortOption.label}</option>
                  `;
                })}
              </select>
            </div>
          `;
  },
  productsPerPage: function(html, args) {
    var onClick = function (e) {
      const mutationCallback = (reqState) => {
        console.log(e.target);
        //this.setAttribute("checked", "checked");
        e.checked = true;

        reqState.perPage = parseInt(e.target.value);
        return reqState;
      };
      args.props.helpers.setRequestState(mutationCallback);
    };
    var onChange = function (e) {
      const mutationCallback = (reqState) => {
        reqState.perPage = parseInt(e.target.value);
        return reqState;
      };
      args.props.helpers.setRequestState(mutationCallback);
    };
    var defaultChecked = html`<input type="radio" name="product-per-page-mobile" value="60" onchange=${onClick} />`;
    if (args.props.helpers.getRequestState().perPage == 60) {
      defaultChecked = html`<input type="radio" checked name="product-per-page-mobile" value="60" onchange=${onClick} />`;
    }
    return html`
      <select class="product-per-page" name="per-page" onchange=${onChange}>
        <option value="${window.plp_vars.plp_limit}">${args.labels.products.productsPerPage}</option>
        <option value="24">24</option>
        <option value="36">36</option>
        <option value="48">48</option>
        <option value="60">60</option>
        <option value="72">72</option>
        <option value="84">84</option>
      </select>
      <div class="product-per-page-mobile">
        <div class="collection__filter filter collapsed">
          <div class="filter__label filter-header filter-header--toggle">
            <h3 class="filter-heading filter__button">${args.labels.products.productsPerPage}</h3>
            <div class="filter-actions">
              <span class="filter-action-toggle-collapse">
                ${window.tagalysIcon.chevron.down(html)}${window.tagalysIcon.chevron.up(html)}
              </span>
            </div>
          </div>
          <div class="filter-body filter-body-range filter__list">
            <div class="range-slider filter-item">
              <div class="radio-inline">
                <label>
                  <input type="radio" name="product-per-page-mobile" value="24" onchange=${onClick} />
                    24
                </label>
              </div>
              <div class="radio-inline">
                <label>
                  <input type="radio" name="product-per-page-mobile" value="36" onchange=${onClick} />
                  36
                </label>
              </div>
              <div class="radio-inline">
                <label>
                  ${defaultChecked}
                  60
                </label>
            </div>
            <div class="radio-inline">
              <label>
                <input type="radio" name="product-per-page-mobile" value="72"  onchange=${onClick} />
                72
              </label>
            </div>
            <div class="radio-inline">
              <label for="per-page-80">
                <input type="radio" name="product-per-page-mobile" value="84" onchange=${onClick} />
                84
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    `;
  },
  variantSelect: function(html, args) {
    var product = args.props.product;
    var variants = product.variants;
    return html`
            <select name="id" class="no-js" aria-label="Select variant" data-product-select>
              ${variants.map((variant, i) => {
                return html`
                  <option ${
                    i === 0 ? 'selected="selected"' : ""
                  } data-i-${i} value="${variant.id}"
                    >${variant.title}
                  </option>
                `;
              })}
            </select>
          `;
  },
  variantOption: {
    header: function(html, args) {
      return html`<span class="variant-picker__message visually-hidden" tabindex="-1">
                    ${args.labels.products.selectOption}
                  </span>`;
    },
    variantList: function(html, args) {
      var product = args.props.product;
      var variants = product.variants;

      return html`${variants.map((variant) => {
        if (variant.available) {
          return html`
            <div role="listitem" class="product-card__variant-container">
              <button class="btn btn--text add-product-variant" data-variant-id="${variant.id}">
                ${variant.title}
              </button>
            </div>
          `;
        } else {
          return html`
            <div role="listitem" class="product-card__variant-container">
              <button
                class="btn btn--text add-product-variant"
                disabled="disabled"
                data-variant-id="${variant.id}"
              >
                ${variant.title}
              </button>
            </div>
          `;
        }
      })}`
    },
    variantListMobile: function(html, args) {
      var product = args.props.product;
      var variants = product.variants;

      return html`${variants.map((variant) => {
        if (variant.available) {
          return html`
            <div role="listitem" class="product-card__variant-container">
              <button class="btn btn--text add-product-variant" data-variant-id="${variant.id}">
                ${variant.title}
              </button>
            </div>
            <div role="listitem">
              <button class="product-card__variant add-product-variant" data-variant-id="${variant.id}">
                <span class="product-card__variant-text">${variant.title}</span>
                ${window.tagalysIcon.checkmark(html)}
              </button>
            </div>
          `;
        } else {
          return html`
            <div role="listitem" class="product-card__variant-container">
              <button
                class="btn btn--text add-product-variant"
                disabled="disabled"
                data-variant-id="${variant.id}"
              >
                ${variant.title}
              </button>
            </div>
            <div role="listitem">
              <button class="product-card__variant add-product-variant" data-variant-id="${variant.id}">
                <span class="product-card__variant-text">${variant.title}</span>
                ${window.tagalysIcon.checkmark(html)}
              </button>
            </div>
          `;
        }
      })}`
    }
  },
  collectionResultsCount: function(html, args){
    const props = args.props;
    const helpers = props.helpers;
    const countText = helpers.getTotalProductsCount() ? args.labels.searchResults.productsCount.replace("{{productsCount}}", helpers.getTotalProductsCount()) : "";
    return html`<span class="collection__tab--results-no"> ${countText}</span>`;
  },
  updateProductCards: function(selector = ".product-card"){
    const productCards = document.querySelectorAll(selector);
    if (productCards && productCards.length) {
      productCards.forEach((productCardElement) => {
        new window.theme.ProductCard(productCardElement, "tagalys");
        const pid = productCardElement.dataset.pid;
        const productCardBadge = productCardElement.querySelector(`[data-product-card-badge="${pid}"]`);
        if (productCardBadge) {
          theme.switchBadgeCurrency.updateProductCardBadges(selector);
        }
      });
    }
  },
  checkStickyElements: function() {
    var filterBarElement = document.querySelector(".collection__tabs");
    var filterWrapperElement = document.querySelector(".filter-wrapper");
    var headerElement = document.querySelector("#shopify-section-header");
    var headerElementHeight = headerElement
      ? headerElement.getBoundingClientRect().height
      : 0;
    var headerHeight = headerElementHeight - 2;


    if( window.innerWidth >= theme.settings.grid_medium ) {
      if( filterWrapperElement ) {
        stickybits(".filter-wrapper-old", {
          stickyBitStickyOffset: headerHeight,
          useStickyClasses: true,
          useGetBoundingClientRect: true,
        });
        stickybits(".filter-wrapper", {
          stickyBitStickyOffset: headerHeight,
          useStickyClasses: true,
          useGetBoundingClientRect: true,
        });
      }
    } else {
      if( filterBarElement ) {
        stickybits(".plp-header", {
          stickyBitStickyOffset: headerHeight,
          useStickyClasses: true,
          useGetBoundingClientRect: true,
        });
      }
    }
  },
  attachSearchListener(helpers){
    const searchInputs = document.querySelectorAll(".search__input");
    if (!searchInputs || searchInputs.length === 0) {
      return;
    }
    searchInputs.forEach((inputEL) => {
      inputEL.addEventListener("focus", function () {
        const filtersDrawer = document.querySelector(
          ".show-filters-in-drawer"
        );
        if (filtersDrawer && helpers.isFilterDrawerOpen()) {
          helpers.closeFilterDrawer();
        }
      });
    });
  },
  hideOpenedVariants(){
    var product_card_show_variants = document.querySelectorAll(
      ".product-card__variants--show"
    );
    product_card_show_variants.forEach((variant) => {
      variant.classList.remove("product-card__variants--show");
    });
  },
  getPrice(product){
    var price = product.price;
    var compareAtPrice = product.compare_at_price;
    var sortedVariants = product.variants.sort((a, b) => {
      return a.price - b.price;
    });
    var firstAvailableVariant = sortedVariants.find(variant => variant.available === true);
    if(firstAvailableVariant){
      price = firstAvailableVariant.price;
      compareAtPrice = firstAvailableVariant.compare_at_price;
    }
    return {price, compareAtPrice}
  },
  getTags(tags){
    let isOnlyInStore = false, isOnlyInStoreClass = "", offer = "", offerProperty = "", badge = "", badgeStyles = "";
    if( tags.length ) {
      tags.forEach((tag) => {
        if (tag === "in-store") {
          isOnlyInStore = true;
          isOnlyInStoreClass = "hide";
        }
        if (tag.includes("offer:")) {
          let badgeParts = tag.split(":");
          offer = badgeParts[1];
          badge = badgeParts[1];
          badge = badge.replaceAll("-", " ");
          if (badgeParts[2]) {
            var badgeBackgroundColour = badgeParts[2];
            badgeStyles = `background-color: ${badgeBackgroundColour};`;
          }
          if (badgeParts[3]) {
            var badgeTextColour = badgeParts[3];
            badgeStyles = `${badgeStyles} color: ${badgeTextColour};`;
          }
        }
      })
      if( offer ) {
        offerProperty = offer.replace("-for-", "-");
      }
    }

    return {
      isOnlyInStore, isOnlyInStoreClass, offer, offerProperty, badge, badgeStyles
    }
  },
  rangeSliderFilterItem(html, args){
    const props = args.props;
    const helpers = props.helpers;
    let priceLabel = args.labels.filters.any;

    if (
      props.sliderInputValues[0] > props.filter.min &&
      props.sliderInputValues[1] < props.filter.max
    ) {
      priceLabel =
        args.labels.filters.between + " " +
        helpers.labelFormatter(
          props.filter.display_format,
          props.sliderInputValues[0],
          props.filter.currency
        ) +
        " - " +
        helpers.labelFormatter(
          props.filter.display_format,
          props.sliderInputValues[1],
          props.filter.currency
        );
    } else if (props.sliderInputValues[0] > props.filter.min) {
      priceLabel =
        args.labels.filters.above + " " +
        helpers.labelFormatter(
          props.filter.display_format,
          props.sliderInputValues[0],
          props.filter.currency
        );
    } else if (props.sliderInputValues[1] < props.filter.max) {
      priceLabel =
        args.labels.filters.below + " " +
        helpers.labelFormatter(
          props.filter.display_format,
          props.sliderInputValues[1],
          props.filter.currency
        );
    }
    var minPriceValue = window.Currency.formatMoney(
      props.sliderInputValues[0] * 100,
      window.Currency.moneyFormats[window.Shopify.currency.active]
        .money_format
    );
    var maxPriceValue = window.Currency.formatMoney(
      props.sliderInputValues[1] * 100,
      window.Currency.moneyFormats[window.Shopify.currency.active]
        .money_format
    );
    var priceValueLeft = "0%";
    if (props.sliderInputValues[0] > props.filter.min) {
      priceValueLeft =
        ((props.sliderInputValues[0] - props.filter.min) / props.filter.max) *
        100;
      priceValueLeft += "%";
    }
    var priceValueRight = "0%";
    if (props.sliderInputValues[1] < props.filter.max) {
      // eslint-disable-next-line no-mixed-operators
      priceValueRight =
        (100 - props.sliderInputValues[1] / props.filter.max) * 100;
      priceValueRight += "%";
    }

    var priceValueLeftClass = "";
    var priceValueRightClass = "";

    if (document.querySelector(".noUi-handle-lower.noUi-active")) {
      priceValueLeftClass = "drag";
    }
    if (document.querySelector(".noUi-handle-upper.noUi-active")) {
      priceValueRightClass = "drag";
    }

    return {priceLabel, minPriceValue, maxPriceValue, priceValueLeft, priceValueRight, priceValueLeftClass, priceValueRightClass}
  }
}
